<template>
  <div>
    <highcharts class="chart" :options="chartOptions" />
  </div>
</template>

<script>
  export default {
    props: { chartInfo: { type: Object, default: null } },
    data() {
      return {
        seriesColor: "#6fcd98",
        colorInputIsSupported: null,
        chartOptions: {
          chart: {
            marginRight: 20,
            backgroundColor: "rgba(255, 255, 255, 0)",
            plotBackgroundColor: "rgba(255, 255, 255, .9)",
            plotShadow: true,
            plotBorderWidth: 1,
            zoomType: "x",
            resetZoomButton: {
              position: {
                x: -10,
                y: -40,
              },
            },
          },
          credits: {
            enabled: false,
          },
          exporting: {
            enabled: false,
          },
          type: "line",
          title: {
            text: this.chartInfo.title,
          },
          series: [
            {
              data: this.seriesData(),
              color: "#5aca81",
              animation: false,
              showInLegend: false,
              marker: {
                radius: 4,
                lineColor: null,
                enabled: true,
                fillColor: "white",
                lineWidth: 2,
              },
            },
          ],
          subtitle: {
            text: this.chartInfo.subtitle,
          },
          xAxis: {
            type: "datetime",
            dateTimeLabelFormats: {
              year: "%b-%e",
              week: "%b-%e",
              month: "%b-%e",
              day: "%b-%e",
              hour: "%b-%e",
              minute: "%b-%e",
              second: "%b-%e",
              millisecond: "%b-%e",
            },
            labels: {
              format: "{value:%b-%e}",
            },
            minTickInterval: 1,
            minRange: 1209600000, // 2 weeks in milliseconds,
            startOnTick: true,
            endOnTick: true,
          },
          yAxis: {
            allowDecimals: this.allowDecimals(),
            title: {
              text: this.chartInfo.y_axis.title,
            },
            tickInterval: null,
            lineWidth: 1,
            minorTickWidth: 1,
            minorTickLength: 3,
            minorGridLineColor: "#DDDDDD",
            minorTickInterval: "auto",
          },
          tooltip: {
            pointFormat: "{point.notes}",
            crosshairs: true,
            useHTML: true,
          },
          plotOptions: {
            series: {
              marker: {
                enabled: true,
              },
              stickyTracking: false,
            },
          },
        },
      };
    },
    methods: {
      seriesData: function () {
        const series = [];

        this.chartInfo.series.forEach((line) => {
          line.data.forEach((plotPoint) => {
            const timestamp = new Date(plotPoint.x);
            const coordinates = { x: timestamp, y: plotPoint.y };
            const notes = [];
            if (plotPoint.point_display_text != null) {
              notes.push(`${plotPoint.point_display_text}<br>`);
            }

            const j = plotPoint.measurements_display_data.length;
            const chunk = 3;

            let subset;

            if (j > 0) {
              notes.push("<table style='padding-top: 10px;'>");
              for (let i = 0; i < j; i += chunk) {
                subset = plotPoint.measurements_display_data.slice(
                  i,
                  i + chunk
                );
                const message = ["<tr>"];
                subset.forEach((displayData) => {
                  message.push(
                    "<td><div style='float:left; width:100%; padding-top: 10px; padding-right:15px'>"
                  );

                  let timeStamp = displayData.timestamp;
                  if (timeStamp != null) {
                    timeStamp = `<b>${timeStamp} </b><br>`;
                    message.push(timeStamp);
                  }

                  const values = displayData.values;
                  if (values != null && values.length > 1) {
                    message.push(values.join("<br>"));
                  } else if (values != null) {
                    message.push(values);
                  }

                  const note = displayData.note;
                  if (note) {
                    message.push(
                      `<br><b>${this.$t("titles.notes")}:</b><br> ${note}`
                    );
                  }
                  message.push("</div></td>");
                });
                message.push("</tr>");
                notes.push(message.join(""));
              }
              notes.push("</table>");
            }

            coordinates["notes"] = notes.join("");

            if (plotPoint.fill_point) {
              coordinates["marker"] = {
                symbol: "circle",
                fillColor: "#5aca81",
              };
            }
            series.push(coordinates);
          });
        });
        return series;
      },
      allowDecimals: function () {
        if (this.chartInfo.chart_type == "baby_weight_kg") {
          return true;
        } else {
          return false;
        }
      },
    },
  };
</script>

<style scoped></style>
